import type { GetInquiryHistoryResponse } from '@/types/chat/chat';
import { httpServices } from './client';

/** Questions and answers of an inquiry (`/llm/chat/message`). */

export interface MessagePageParams {
  /** Cursor from the previous page's `next_cursor`; null for the newest page. */
  before?: string | null;
  size: number;
}

/** GET /llm/chat/message/{inquiryId}, newest first. */
export const getMessages = (inquiryId: string, params: MessagePageParams) =>
  httpServices.llmService.get<GetInquiryHistoryResponse>(
    `/chat/message/${inquiryId}`,
    params,
  );

/**
 * Every message of an inquiry (GET /llm/chat/message/{inquiryId} without a
 * cursor), so questions and answers can be numbered.
 */
export const getConversation = (inquiryId: string) =>
  httpServices.llmService.get<GetInquiryHistoryResponse>(
    `/chat/message/${inquiryId}`,
  );
